/*jshint esversion: 11 */
import sendApiRequest from '../helpers/axios-setup';

/**
 * GET attendance list
 * @returns {Promise}
 */
export async function getLeaveBalance(staff_id) {
  try {
    const response = await sendApiRequest.get('/attendance/balance',{
      params:{staff_id}
    });
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 * GET attendance list
 * @returns {Promise}
 */
export async function getAttendanceList(
  page,
  limit,
  {
    filter_user_id = '',
    start_date = '',
    end_date = '',
    filter_status = '',
    filter_type = '',
    filter_deleted = '',
    isConsumed = '',
    isCancelled = ''
  } = {}
) {
  try {
    const response = await sendApiRequest.get('/attendance', {
      params: {
        page,
        limit,
        filter_user_id,
        start_date,
        end_date,
        filter_status,
        filter_type,
        filter_deleted,
        isConsumed,
        isCancelled
      }
    });

    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

/**
 * CREATE attendance (Staff)
 * @returns {Promise<Object>}
 */
export async function addNewAttendance(
  leave_reason,
  start_date,
  end_date,
  type
) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.post('/attendance', {
      leave_reason,
      start_date,
      end_date,
      type
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

/**
 * GET single attendance
 * @param {String} attendanceId
 * @returns
 */
export async function getAttendanceInfo(attendanceId) {
  try {
    const response = await sendApiRequest.get(`/attendance/${attendanceId}`);
    return response.data?.data;
  } catch (e) {
    return null;
  }
}

/**
 * UPDATE attendance (Super Admin)
 * @returns {Promise<Object>}
 */
export async function updateAttendance(
  attendanceId,
  marked_by,
  status,
  type,
  remarks,
  leave_reason,
  start_date,
  end_date
) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.put(`/attendance/${attendanceId}`, {
      marked_by,
      status,
      type,
      remarks,
      leave_reason,
      start_date,
      end_date
    });
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

/**
 * DELETE / RESTORE attendance
 * @param {String} attendanceId
 * @param {String} type delete | restore
 * @returns
 */
export async function deleteRestoreAttendance(attendanceId, type) {
  const responseMap = {
    response: null,
    error: null
  };

  try {
    const response = await sendApiRequest.delete(
      `/attendance/${attendanceId}`,
      {
        params: { type }
      }
    );
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}

/**
 * CANCEL attendance (staff request / admin approve / admin reject)
 * @param {String} attendanceId
 * @param {'request' | 'approve' | 'reject'} action
 * @returns {Promise<Object>}
 */
export async function cancelAttendance(attendanceId, action) {
  const responseMap = {
    response: null,
    error: null
  };

  let payload = {
    cancel_action: 'Pending'
  };

  if (action === 'Approved') {
    payload = {
      cancel_action: 'Approved'
    };
  }

  if (action === 'Rejected') {
    payload = {
      cancel_action: 'Rejected'
    };
  }

  try {
    const response = await sendApiRequest.put(
      `/attendance/${attendanceId}/cancel`,
      payload
    );
    responseMap.response = response.data;
  } catch (e) {
    responseMap.error = e?.response?.data?.error;
  }

  return responseMap;
}
